import { useEffect, useRef } from 'react';
import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../../../constants/constants';
import useNRQuery from '../../../../graphql/useNRQuery';
import { GET_JIRA_INTEGRATION } from '../../../../graphql/queries/jiraIntegration';
import { JIRA_INTEGRATION_STATUS } from './jiraIntegration.constants';
import { JIRA_CONNECTION_HEALTH_ISSUE } from './jiraIntegrationDetail.constants';
import { getJiraConnectionHealthIssue } from './jiraIntegration.utils';

function useIsJiraIntegrationActive() {
  const { value: isJiraIntegrationEnabled } = useFlag(FEATURE_FLAGS.SETTINGS_JIRA_INTEGRATION, false);

  const [jiraIntegration, isLoading] = useNRQuery({
    query: GET_JIRA_INTEGRATION,
    options: { skip: !isJiraIntegrationEnabled },
    qlObjKey: 'jiraIntegration',
    defaultValue: null
  });

  const lastJiraIntegrationRef = useRef(null);

  useEffect(() => {
    if (jiraIntegration) {
      lastJiraIntegrationRef.current = jiraIntegration;
    }
  }, [jiraIntegration]);

  const resolvedJiraIntegration = jiraIntegration ?? lastJiraIntegrationRef.current;

  const isJiraIntegrationActive = isJiraIntegrationEnabled && resolvedJiraIntegration?.status === JIRA_INTEGRATION_STATUS.CONNECTED;
  const healthIssue = resolvedJiraIntegration
    ? getJiraConnectionHealthIssue({
        status: resolvedJiraIntegration.status,
        jiraInstallationId: resolvedJiraIntegration.jiraInstallationId,
        oauthTokenActive: resolvedJiraIntegration.oauthTokenActive,
        apiConnectivityActive: resolvedJiraIntegration.apiConnectivityActive
      })
    : null;
  const isJiraDisconnected = healthIssue === JIRA_CONNECTION_HEALTH_ISSUE.DISCONNECTED;
  const canDirectReconnect = Boolean(resolvedJiraIntegration?.oauthInstallStepComplete) && Boolean(resolvedJiraIntegration?.jiraAppInstalledComplete);

  return {
    isJiraIntegrationActive,
    isJiraDisconnected,
    isJiraIntegrationLoading: isJiraIntegrationEnabled && isLoading && !resolvedJiraIntegration,
    canDirectReconnect
  };
}

export default useIsJiraIntegrationActive;
